import React, { useState, useEffect, useContext, useCallback } from 'react'
import { Row, Form, Col, Button, Modal } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import CargandoDatosLoader from 'components/CargandoDatosLoader'
import { AltaContext } from './AltaContext'
import { useApiCall } from './Hooks'
import { mainRequest } from 'utils/requests'

function Terminos() {
  const [pasoActual, setPasoActual] = useState({})
  const [show, setShow] = useState(false)
  const [checks, setChecks] = useState({ uno: false, dos: false, tres: false })
  const { setVerified, setCallback, setPaso } = useContext(AltaContext)
  const location = useLocation()

  const [loading] = useApiCall('/ddjj/alta/api/paso-actual', setPasoActual)

  useEffect(() => {
    if (location?.state?.visualizarDatos || location?.state?.modificarDatos)
      setPaso(2)
    else setPaso(pasoActual?.paso ?? 1)
  }, [pasoActual, setPaso, location])

  const storeData = useCallback(() => {
    return mainRequest('/ddjj/alta/api/confirmar-terminos', {
      method: 'POST',
      body: JSON.stringify({})
    }).then(({ status, content }) => {
      setPaso(1)
      return content.success
    })
  }, [setPaso])

  useEffect(() => {
    setCallback(storeData)
    setVerified(checks.uno && checks.dos && checks.tres)
  }, [checks, setCallback, setVerified, storeData])

  return (
    <CargandoDatosLoader cargando={loading}>
      <Row>
        <div className="col-lg-12 order-md-2">
          <h6 className="text-muted text-normal text-uppercase">
            Pautas de Funcionamiento del Sistema
          </h6>
          <hr className="margin-bottom-1x" />
          <div className="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x">
            <span className="alert-close" data-dismiss="alert"></span>
            <i className="icon-bell"></i>&nbsp;&nbsp;
            <strong>Importante:</strong> Debe aceptar las pautas del sistema
            para poder avanzar.
          </div>
          <Form.Row>
            <Col>
              <Form.Group className="custom-control custom-checkbox custom-control-inline">
                <Form.Control
                  type="checkbox"
                  id="primer-check"
                  className="custom-control-input"
                  checked={checks.uno}
                  onChange={(e) =>
                    setChecks((checks) => ({
                      ...checks,
                      uno: e.target.checked
                    }))
                  }
                />
                <Form.Label
                  className="custom-control-label"
                  htmlFor="primer-check"
                >
                  Los datos declarados en la presente Declaración Jurada quedan
                  sujetos a verificación y control por la Autoridad de
                  Aplicación. En caso de que falsee u omita algún dato, será
                  pasible de sanciones legalmente previstas.
                </Form.Label>
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="custom-control custom-checkbox custom-control-inline">
                <Form.Control
                  type="checkbox"
                  id="segundo-check"
                  className="custom-control-input"
                  checked={checks.dos}
                  onChange={(e) =>
                    setChecks((checks) => ({
                      ...checks,
                      dos: e.target.checked
                    }))
                  }
                />
                <Form.Label
                  className="custom-control-label"
                  htmlFor="segundo-check"
                >
                  Acepto registrar y confirmar datos para el domicilio fiscal
                  electrónico conforme a la reglamentación vigente.
                </Form.Label>
              </Form.Group>

              <Form.Group className="custom-control custom-checkbox custom-control-inline">
                <Form.Control
                  type="checkbox"
                  className="custom-control-input"
                  checked={checks.tres}
                  onChange={() => null}
                />
                <Form.Label
                  as={Button}
                  className="custom-control-label"
                  variant="link"
                  onClick={() => setShow(true)}
                >
                  Términos y condiciones
                </Form.Label>
              </Form.Group>
            </Col>
          </Form.Row>
        </div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          scrollable
          size="xl"
          style={{ zIndex: 9001 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Domicilio fiscal electrónico</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <b>
                Registración y confirmación de datos para la constitución de
                Domicilio Fiscal Electrónico.
              </b>
            </p>
            <p>
              <b>¿Qué es el Domicilio Fiscal Electrónico? </b>
            </p>
            <p>
              El Domicilio Fiscal Electrónico es el sitio informático seguro,
              personalizado y válido, de los contribuyentes y responsables para
              la entrega y recepción de comunicaciones, notificaciones e
              intimaciones, de cualquier naturaleza que determine el Municipio.
            </p>
            <p>
              <b>¿Es obligatorio? ¿Qué efectos produce? </b>
            </p>
            <p>
              El Domicilio Fiscal Electrónico es obligatorio para todos los
              contribuyentes y responsables de la Tasa por Inspección de
              Seguridad e Higiene y produce, en el ámbito administrativo, los
              efectos del domicilio fiscal constituido, por lo que, a través de
              las comunicaciones, notificaciones e intimaciones que se reciban
              por este medio, se considerará al contribuyente como efectivamente
              notificado.
            </p>
            <p>
              Asimismo, los documentos digitales que se trasmitan mediante el
              Domicilio Fiscal Electrónico tienen plena validez y eficacia
              jurídica, constituyendo medio de prueba suficiente de su
              existencia y de la información contenida en ellos.
            </p>
            <p>
              <b>¿Cómo constituyo mi Domicilio Fiscal Electrónico? </b>
            </p>
            <p>
              La constitución de Domicilio Fiscal Electrónico es realizada por
              la Municipalidad de Berisso para todos los contribuyentes y
              responsables de la Tasa por Inspección de Seguridad e Higiene.
              Cada contribuyente o responsable deberá registrar y confirmar sus
              datos para la constitución al momento de su inscripción en el
              tributo, o posteriormente, declarando una dirección de correo
              electrónico y un número de teléfono celular.
            </p>
            <p>
              <b>
                ¿Para qué son utilizados mis datos de contacto registrados?{' '}
              </b>
            </p>
            <p>
              La Municipalidad de Berisso utilizará los datos de correo
              electrónico y teléfono celular para informar, por cortesía, la
              existencia de novedades en el Domicilio Fiscal Electrónico de cada
              contribuyente o responsable.
            </p>
            <p>
              <b>¿Cómo funciona? </b>
            </p>
            <p>
              La Municipalidad de Berisso publicará en el Domicilio Fiscal
              Electrónico de cada contribuyente o responsable, comunicaciones,
              notificaciones e intimaciones, y le enviará un correo electrónico
              de cortesía, informando la existencia de dicha publicación.
            </p>
            <p>
              Las comunicaciones, notificaciones e intimaciones, se considerarán
              efectivamente notificadas en los siguientes momentos, el que
              ocurra primero:
            </p>
            <p>
              a) El día en que el contribuyente, responsable y/o persona
              debidamente autorizada, proceda a la apertura del documento
              digital que contiene la comunicación, notificación o intimación.
            </p>
            <p>
              b) A las 00:00 horas del día martes y viernes inmediato posterior
              a la fecha en que las comunicaciones, notificaciones e
              intimaciones se encontraran disponibles en el Domicilio Fiscal
              Electrónico.
            </p>
            <p>
              <b>
                ¿Cómo me notifico de las publicaciones en mi Domicilio Fiscal
                Electrónico?
              </b>
            </p>
            <p>
              Accediendo al sito informático mediante Clave Fiscal de AFIP
              (Nivel 3) cuando la Municipalidad de Berisso me informe novedades
              en mi correo electrónico.
            </p>
            <p>
              <b>¿Qué pasa si no registro o confirmo mis datos? </b>
            </p>
            <p>
              La falta de registro y confirmación de datos no impide la validez
              de las comunicaciones, notificaciones e intimaciones publicadas en
              el Domicilio Fiscal Electrónico. Sólo impide que el contribuyente
              o responsable tenga conocimiento de las novedades que se van
              registrando en dicho sitio.
            </p>
            <p>
              <b>¿Dónde puedo obtener más información? </b>
            </p>
            <p>
              A través de los canales de comunicación de la Dirección de
              Ingresos Públicos: Correo electrónico: dip@berisso.gob.ar.
              Teléfono y WhatsApp: 221 464-5569/ 221 464-5570. Horario de
              atención: lunes a viernes de 09:00 horas a 14:00 horas.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cerrar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setShow(false)
                setChecks({ ...checks, tres: true })
              }}
            >
              Aceptar Términos
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    </CargandoDatosLoader>
  )
}

export default Terminos
